import _URL from '../URL/index';
const axios = _URL.axios;
const limit = 15

export default {
    services: {
        getDrivers: async (limit, page, query, token) => {
            return await axios(token).get(`/drivers?limit=${limit}&page=${page}${query ? `&${query}` : ""}`);
        },
        created: async (driver, token) => {
            return await axios(token).post(`/drivers`, driver);
        },
        getOneDriver: async (_id, token) => {
            return await axios(token).get(`/drivers/${_id}`);
        },
        updateDriver: async (_id, driver, token) => {
            return await axios(token).put(`/drivers/${_id}`, driver);
        },
        deleteDriver: async (_id, token) => {
            return await axios(token).delete(`/drivers/${_id}`);
        },
        deleteManyDrivers: async (_ids, token) => {
            return await axios(token).post(`/deleted/drivers`, { _ids: _ids });
        },
        uploadFIle: async (formData, token) => {
            return await axios(token).post(`/picture/upload/drivers`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        },
        downloadCVS: async (driver, token) => {
            return await axios(token).post(`/export/drivers`, driver);
        },
        getDriversByCompanies: async (_id, pagination, token) => {
            if (Object.entries(pagination).length === 0) {
                return await axios(token).get(`/drivers/companies/${_id}`);
            } else {
                return (pagination.type === "change") ? await axios(token).get(`/drivers/companies/${_id}?limit=${limit}&page=${pagination.page}`) : await axios(token).get(`${pagination.url}`);
            }
        },
        getDriversBySuppliers: async (_id, pagination, token) => {
            if (Object.entries(pagination).length === 0) {
                return await axios(token).get(`/drivers/suppliers/${_id}`);
            } else {
                return (pagination.type === "change") ? await axios(token).get(`/drivers/suppliers/${_id}?limit=${limit}&page=${pagination.page}`) : await axios(token).get(`${pagination.url}`);
            }
        },
        getDriversByBranchId: (branchId, token) => {
            return axios(token).get(`/drivers/branches/${branchId}`);
        },
        createdSchedule: async (schedule, token) => {
            return await axios(token).post(`/schedules`, schedule);
        },
        updateSchedule: async (_id, schedule, event, update, action, token) => {
            return await axios(token).put(`/schedules/${_id}`, { schedule: schedule, event: event, update: update, action: action });
        },
        deleteSchedule: async (_id, token) => {
            return await axios(token).delete(`/schedules/${_id}`);
        },
        getAllEventsByDriver: async (_id, month, year, token) => {
            return await axios(token).get(`/schedules/drivers/${_id}?month=${month}&year=${year}`);
        },
        getAllEvents: async (month, year, token) => {
            return await axios(token).get(`/schedules?month=${month}&year=${year}`);
        },
        getOneSchedule: async (_id, token) => {
            return await axios(token).get(`/schedules/${_id}`);
        },
        delete: async (_id, token) => {
            return await axios(token).delete(`/schedules/${_id}`);
        },
        deletedEvent: async (_id, event_id, option, token) => {
            return await axios(token).put(`/schedule/delete/${_id}`, { event_id: event_id, option: option });
        },
        updateScheduleDragAndDrop: async (_id, option, event, days, token) => {
            return await axios(token).put(`/schedule/draganddrop/${_id}`, { option: option, days: days, event: event });
        },
        updateAnyAttribute: async (_id, body, token) => {
            return await axios(token).patch(`/drivers/${_id}`, body);
        },
        getDriversByBranches:(branches = [], token) => {
            return axios(token).post(`/branches/drivers-options`, { branches : branches });
        },
        getDriversByBranchId:(branchId, token = "") => {
            return axios(token).get(`/branches/${branchId}/drivers-options`);
        },
        createPartialDriverProfile:(branchId, driver, token= "") => {
            return axios(token).post(`/branches/${branchId}/drivers`, driver);
        },
    }
}